import {useIntl, FormattedMessage} from 'react-intl'
import {FAQ_ACCORDION_ITEMS} from './core/_const'
import {Link} from 'react-router-dom'
import {PublicWrapper} from '../../modules/common/components/PublicWrapper'
import {PricingTiers} from '../../modules/common/components/PricingTiers'
import {StartFreeToday} from './components/StartFreeToday'
import {SeoHead} from '../../modules/seo'

export function PricingPage() {
  const intl = useIntl()

  return (
    <>
      <PublicWrapper>
        <SeoHead />
        <div className='pricing-page-container'>
          <section className='hero pb-26'>
            <h1
              className='custom-h1 text-center text-primary darker-primary mb-4'
              dangerouslySetInnerHTML={{
                __html: intl.formatMessage({id: 'PRICING_H1'}),
              }}
            ></h1>
            <p
              className='text-center text-gray-700 fw-bold'
              dangerouslySetInnerHTML={{
                __html: intl.formatMessage({id: 'PRICING_SUBTITLE'}),
              }}
            ></p>
          </section>

          <PricingTiers />

          <section className='pricing-faq container mt-25'>
            <h2 className='mb-12 text-left lh-sm'>{intl.formatMessage({id: 'PRICING_FAQ'})}</h2>

            {FAQ_ACCORDION_ITEMS.map((accordionItem, index) => {
              const headingId = `heading-${index}`
              const collapseId = `collapse-${index}`

              return (
                <div
                  key={index}
                  className='accordion-container alt-accordion mt-12'
                  id='faqAccordion'
                >
                  <div className='accordion-item'>
                    <h4 className='accordion-header' id={headingId}>
                      <button
                        className='accordion-button collapsed'
                        type='button'
                        data-bs-toggle='collapse'
                        data-bs-target={`#${collapseId}`}
                        aria-expanded='false'
                        aria-controls={collapseId}
                      >
                        {intl.formatMessage({id: accordionItem.title})}
                      </button>
                    </h4>
                    <div
                      id={collapseId}
                      className='accordion-collapse collapse'
                      aria-labelledby={headingId}
                      data-bs-parent='#faqAccordion'
                    >
                      <div className='accordion-body'>
                        <p className='mb-0'>
                          <FormattedMessage
                            id={accordionItem.content}
                            values={{
                              link: (chunks: React.ReactNode) => (
                                <Link
                                  to='/service-terms'
                                  className='text-primary-deep text-hover-primary'
                                >
                                  {chunks}
                                </Link>
                              ),
                              email: (chunks: React.ReactNode) => (
                                <a
                                  href='mailto:support@goricompany.com'
                                  className='text-primary-deep text-hover-primary'
                                >
                                  {chunks}
                                </a>
                              ),
                            }}
                          />
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              )
            })}
          </section>

          <StartFreeToday />
        </div>
      </PublicWrapper>
    </>
  )
}
